import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PreventDragdropModule } from '../drag-and-drop/prevent-dragdrop.module';
import { IconModule } from '../icon/icon.module';
import {
  AvatarThemeBackground,
  AvatarThemeDirective,
  AvatarThemeSubject,
} from './avatar-theme.directive';
import { AvatarComponent } from './avatar.component';

@NgModule({
  imports: [CommonModule, IconModule, PreventDragdropModule],
  declarations: [AvatarComponent, AvatarThemeDirective],
  exports: [AvatarComponent, AvatarThemeDirective],
})
export class AvatarModule {}

export { AvatarThemeSubject, AvatarThemeBackground };
export { AvatarComponent } from './avatar.component';
export { AvatarThemeDirective } from './avatar-theme.directive';
